// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-apply-box[data-v-4dd84d9c]{display:flex;width:100%;background:#F7F7F7}.job-box[data-v-4dd84d9c]{flex:1;margin-left:130px;margin-right:20px;padding-top:24px;padding-bottom:60px}.apply-box[data-v-4dd84d9c]{flex:1;margin-right:130px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
